import { SelfServiceAPI } from 'types';
import { format } from 'date-fns';
import createLocalDateTime from '../createLocalDateTime';

const CHECK_IN_DATE_FORMAT = "E d MMM, yyyy. 'From' ha";

const getFormattedCheckInDateTime = (booking: SelfServiceAPI.Booking) => {
  const {
    checkIn,
    property: { checkInAfter },
  } = booking.reservation;
  const localDate = createLocalDateTime(checkIn, checkInAfter);
  return format(localDate, CHECK_IN_DATE_FORMAT);
};

export default getFormattedCheckInDateTime;
